import { createContext } from 'react';
import type { Services } from '@/services/container';

export const ServicesContext = createContext<Services | undefined>(undefined);
